// 재제작·수정 표준 사유 (2026-08-09 대표 승인 — 기획서_치과분석_기공비_재제작_2026-08 §4-1)
//
// 왜 필요한가: 종전에는 사유가 자유 입력(remakeReason)뿐이라 같은 뜻을 제각각 적었고,
// 그래서 "사유별 분포"라는 집계가 성립하지 않았다. 코드값(remakeCause)을 함께 저장해
// 분석에서 묶을 수 있게 한다. 자유 입력은 그대로 남긴다 — 현장 표현이 곧 원인 단서라서 버리지 않는다.
//
// 과거 데이터에는 remakeCause가 없다. 분석 화면은 이를 '미분류'로 표시하고 임의 추정하지 않는다.

export const REMAKE_CAUSES = [
    { code: 'fit', label: '적합 안 됨(마진)', hint: '들뜸·마진 안 맞음' },
    { code: 'occlusion', label: '교합 높음/낮음' },
    { code: 'contact', label: '인접면 접촉' },
    { code: 'shade', label: '색상 불일치' },
    { code: 'fracture', label: '파절·크랙' },
    { code: 'shape', label: '형태 요청' },
    { code: 'other', label: '기타' },
];

// 사유를 고르면 자유 입력칸에 바로 들어가는 기본 문구 (2026-08-11 대표 지시 — 단축어처럼)
// 고르기만 하고 못 넘어가는 일이 없게 한다. 손으로 고친 내용은 절대 덮지 않는다.
export const REMAKE_CAUSE_TEXT = {
    fit: '적합이 안 됩니다 (마진 들뜸)',
    occlusion: '교합이 맞지 않습니다 (높음/낮음)',
    contact: '인접면 접촉이 맞지 않습니다',
    shade: '색상이 맞지 않습니다',
    fracture: '파절·크랙이 생겼습니다',
    shape: '형태 수정 요청드립니다',
    other: '',
};

const _map = REMAKE_CAUSES.reduce((m, c) => { m[c.code] = c.label; return m; }, {});

/** 코드 → 한글 라벨. 코드가 없으면(구 데이터) '미분류' */
export const remakeCauseLabel = (code) => _map[code] || '미분류';
